import React from 'react'
import { COLORS } from 'theme'
import AlarmIcon from 'components/icons/AlarmIcon'
import CandidatesIcon from 'components/icons/CandidatesIcon'
import Cancellation from 'components/icons/Cancellation'
import { getDay } from 'utils/getDay'

import {
  RoleNameFlex,
  RoleNameDiv,
} from 'modules/Roles/Partials/ViewIndividualRole/Components/Styles/Style.js'
import {
  FlexWrap,
  Heading,
  Info,
  VerticalDivider,
} from 'modules/Roles/Partials/ViewIndividualRole/Components/DetailsHeader/style.js'

const DetailsHeader = ({ tittle, status, jobyType, candidatesCount, date }) => {
  return (
    <FlexWrap gap="30px" column>
      <RoleNameFlex alignCenter>
        <RoleNameDiv>{tittle}</RoleNameDiv>
      </RoleNameFlex>

      <FlexWrap alignCenter>
        <FlexWrap gap="5px" alignCenter>
          <AlarmIcon color={COLORS.GREY_T_80} />
          <Info>{jobyType?.split('_')?.join(' ').toLowerCase()}</Info>
        </FlexWrap>

        <VerticalDivider type="vertical" />

        <FlexWrap gap="5px" alignCenter>
          <CandidatesIcon />
          <Info>{candidatesCount}</Info>
        </FlexWrap>

        <VerticalDivider type="vertical" />

        <FlexWrap gap="5px" alignCenter>
          <Cancellation />
          <Heading>Apply before</Heading>
          <Info>{getDay(date, true)}</Info>
        </FlexWrap>
      </FlexWrap>
    </FlexWrap>
  )
}

export default DetailsHeader
